import React, { useState } from 'react';
import { Button } from '@aws-amplify/ui-react';
import './Topmenu.css';

interface TitleSectionProps {
  handler: (buttonName: string) => void;
}

const Topmenu = (props: TitleSectionProps) => {
  const [clickedButton, setClickedButton] = useState<string>('LLM');

  const handleClick = (buttonName: string) => {
    setClickedButton(buttonName);
    props.handler(buttonName)
  };

  return (
    <div className="title-airpreset airpreset">
      <div style={{ marginBottom: '20px' }}>
        <Button
          onClick={() => handleClick('LLM')}
          style={{
            fontWeight: clickedButton === 'LLM' ? 'bold' : 'normal',
            color: clickedButton === 'LLM' ? 'black' : '#646464',
          }}
        >
          LLM
        </Button>
        <Button
          onClick={() => handleClick('Classification')}
          style={{
            fontWeight: clickedButton === 'Classification' ? 'bold' : 'normal',
            color: clickedButton === 'Classification' ? 'black' : '#646464',
          }}
        >
          Classification
        </Button>
        <Button
          onClick={() => handleClick('Slot')}
          style={{
            fontWeight: clickedButton === 'Slot' ? 'bold' : 'normal',
            color: clickedButton === 'Slot' ? 'black' : '#646464',
          }}
        >
          Slot
        </Button>
        <Button
          onClick={() => handleClick('Sentiment')}
          style={{
            fontWeight: clickedButton === 'Sentiment' ? 'bold' : 'normal',
            color: clickedButton === 'Sentiment' ? 'black' : '#646464',
          }}
        >
          Sentiment
        </Button>
        <Button
          onClick={() => handleClick('Model B')}
          style={{
            fontWeight: clickedButton === 'Model B' ? 'bold' : 'normal',
            color: clickedButton === 'Model B' ? 'black' : '#646464',
          }}
        >
          Model B
        </Button>
      </div>
    </div>
  )
}

export default Topmenu;